import { render } from "./ContactComponent.vue?vue&type=template&id=6975c79f&scoped=true"
import script from "./ContactComponent.vue?vue&type=script&lang=js"
export * from "./ContactComponent.vue?vue&type=script&lang=js"

import "./ContactComponent.vue?vue&type=style&index=0&id=6975c79f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6975c79f"]])

export default __exports__